exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".RangeGraph_marker_container{display:flex;flex-direction:column;color:black;position:absolute}.RangeGraph_marker_container>span{text-align:center}\n", ""]);

// Exports
exports.locals = {
	"marker_container": "RangeGraph_marker_container"
};